import { useEffect, useMemo } from 'react';
import {
  Navigate,
  useLocation,
  useNavigate,
  useParams,
} from 'react-router-dom';
import { ProcDetailsResponse, useProcDetails } from '@/shared/api';
import { useFullScreenLoaderEffect } from '@/shared/ui';
import { EditProcView } from './EditProcView';
import { PublishedProcView } from './PublishedProcView';

export const ProcPage = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { procId: id } = useParams();

  const procId = useMemo(() => state?.procId || id, [state, id]);
  const mode = useMemo(() => (state?.procId ? 'create' : 'edit'), [state, id]);

  const {
    data: procData,
    error,
    isLoading,
  } = useProcDetails<ProcDetailsResponse>(
    {
      pathParams: { id: procId },
    },
    {
      onError: (error: any) => {
        if (
          error.stack.statusCode === 400 ||
          error.stack.statusCode === 403 ||
          error.stack.statusCode === 404
        ) {
          navigate('/dashboard/404', { replace: true });
        }
      },
    },
  );

  useFullScreenLoaderEffect(isLoading);

  const isProcPublished = useMemo(
    () => procData?.state === 'published',
    [procData?.state],
  );

  if (error as any) {
    const errorData = error as any;
    const errorCode = errorData?.stack?.error;
    if (errorCode === 'ResourceNotFound') {
      return <Navigate to="/404" />;
    }
  }

  if (!procData) {
    return null;
  }

  return (
    <>
      {isProcPublished ? (
        <PublishedProcView procId={procId} />
      ) : (
        <EditProcView procId={procId} mode={mode} />
      )}
    </>
  );
};
